import { createContext, useContext, useEffect, useState } from "react";
import { apiGet } from "@/lib/api";
import { useAuth } from "./AuthContext";

const WorkspaceContext = createContext(null);
export const WORKSPACE_COLORS = { global: "#18c9ff", elevate: "#8daeff", regen: "#59b9e9", eibattery: "#ffd34e", personal: "#8deaff" };

export function WorkspaceProvider({ children }) {
  const { unlocked } = useAuth();
  const [workspaces, setWorkspaces] = useState([]);
  const [workspace, setWorkspaceState] = useState(localStorage.getItem("jv-workspace") || "global");

  const setWorkspace = (id) => {
    setWorkspaceState(id);
    localStorage.setItem("jv-workspace", id);
  };

  useEffect(() => {
    if (!unlocked) { setWorkspaces([]); return; }
    let active = true;
    const load = () => apiGet("/workspaces").then((records) => { if (active) setWorkspaces(records.map((w) => ({ ...w, color: WORKSPACE_COLORS[w.id] || "#7896ab" }))); }).catch(() => {});
    load(); const timer = setInterval(load, 8000);
    return () => { active = false; clearInterval(timer); };
  }, [unlocked]);

  const current = workspaces.find((w) => w.id === workspace) || { id: "global", name: "JARVIS GLOBAL", short: "GLOBAL", color: "#00e5ff" };

  return (
    <WorkspaceContext.Provider value={{ workspace, setWorkspace, workspaces, current }}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export const useWorkspace = () => useContext(WorkspaceContext);
